import styled from "styled-components/macro";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  background: #f7f7f7f7;
`;

export const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 40px;
  width: 100%;
  .move-btn {
    width: 30px;
    & img {
      width: 100%;
    }
  }
  .pagetit {
    font-size: 1.13em;
    font-family: "spoqa500";
    margin-left: 10px;
  }
  .post-submit {
    font-size: 1.13em;
    padding: 8px 21px;
    background-color: #73972c;
    color: #fff;
    border-radius: 8px;
    border: none;
    position: absolute;
    right: 40px;
    cursor: pointer;
  }

  @media screen and (min-width: 1050px) {
    font-size: 1.4em;
    p {
      & img {
        width: 30%;
      }
    }
  }
`;

export const PageTitle = styled.div`
  width: 100%;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  &.noneborder {
    border: none;
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0px 10px 40px;

    & p {
      font-size: 1.13em;
      color: #2a3a4b;
      margin-left: 15px;
    }

    & button {
      font-size: 0.88em;
      border: 1px solid #73972c;
      color: #73972c;
      padding: 7px 16px;
      border-radius: 5px;
      background-color: #fff;
      margin-left: 28px;
      cursor: pointer;
      &:active {
        background-color: #73972c;
        border: 1px solid #73972c;
        color: #fff;
      }
    }
  }
`;

export const ContentBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
`;

export const ContentItem = styled.div`
  width: 50%;
  padding: 33px 0px 32px 32px;
  margin-top: 10px;
  background-color: #fff;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;

  &:nth-child(2n) {
    border-left: 1px solid #eeeeee;
  }
  .itemlist {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 35px;
    & .list-title {
      width: 30%;
      & p {
        font-family: "Spoqa700";
        font-size: 0.88em;
        color: #2a3a4b;
      }
    }
    & .list-input {
      width: 50%;
      & input {
        width: 100%;
        padding: 5px;
        border: 1px solid #c9c9c9;
        border-radius: 3px;
        font-size: 0.88em;
      }
      & p {
        font-family: "Spoqa700";
        font-size: 0.88em;
        color: #2a3a4b;
      }
    }

    & button {
      padding: 5px 14px;
      background-color: #fff;
      color: #73972c;
      border: 1px solid #73972c;
      border-radius: 5px;
      font-size: 0.88em;
      margin-left: 5px;
      cursor: pointer;
      &:active {
        background-color: #73972c;
        border: 1px solid #73972c;
        color: #fff;
      }
    }
  }

  @media screen and (min-width: 1050px) {
    .itemlist {
      & .list-title {
        width: 15%;
        & p {
          font-size: 1em;
        }
      }
      & .list-input {
        width: 70%;
        & input {
          border-radius: 5px;
          font-size: 1em;
        }
        & p {
          font-size: 1em;
        }
      }

      & button {
        padding: 5px 18px;
        font-size: 1em;
        margin-left: 15px;
      }
    }
  }
`;

export const FeedAddBox = styled.div`
  width: 100%;
  background-color: #fff;
  margin-top: 10px;
  padding: 33px 0px 32px 32px;
  .itemlist {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 20px;
    & .list-title {
      width: 15%;
      & p {
        font-family: "Spoqa700";
        font-size: 0.88em;
        color: #2a3a4b;
      }
    }
    & .list-input {
      width: 70%;

			input{
				border: 1px solid #c9c9c9;
				border-radius: 4px !important;
			}
      & input[type="text"] {
        width: 100%;
        height: 40px;
        padding: 4px 12px;
        border: 1px solid #c9c9c9;
        border-radius: 3px;
        font-size: 0.88em;
      }
      & input[type="date"],
      input[type="time"] {
        width: 50%;
        height: 40px;

        padding: 4px 12px;
        border: 1px solid #c9c9c9;
        border-radius: 3px;
        font-size: 0.88em;
      }
    }

    & button {
      padding: 5px 14px;
      background-color: #fff;
      color: #73972c;
      border: 1px solid #73972c;
      border-radius: 5px;
      font-size: 0.88em;
      margin-left: 20px;
      cursor: pointer;
      &:active {
        background-color: #73972c;
        border: 1px solid #73972c;
        color: #fff;
      }
    }
  }

  @media screen and (min-width: 1050px) {
    .itemlist {
      & .list-title {
        width: 10%;
        text-align: center;
        & p {
          font-size: 1em;
        }
      }
      & .list-input {
        width: 70%;
        & input {
          border-radius: 5px;
          font-size: 1em;
        }
      }

      & button {
        padding: 5px 18px;
        font-size: 1em;
        margin-left: 20px;
      }
    }
  }
`;

export const ModalBox = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  &.open {
    display: block;
  }
  &.close {
    display: none;
  }
`;

export const FeedChangeBox = styled.div`
  width: 42em;
  background-color: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

	padding: 20px;
`;
export const FeedChangeBoxButtonArea = styled.div`
  display: flex;
	justify-content: center;
	margin-top: 20px;

  & button {
    padding: 5px 14px;
    background-color: #fff;
    color: #73972c;
    border: 1px solid #73972c;
    border-radius: 5px;
    font-size: 0.88em;
    margin-right: 10px;
    cursor: pointer;
    &:active {
      background-color: #73972c;
      border: 1px solid #73972c;
      color: #fff;
    }
  }
`;
export const FeedChangeItem = styled.div`
  width: 100%;
  background-color: #fff;
	padding-bottom: 20px;
  border-bottom: 1px solid #eeeeee;


  .itemlist {
    display: flex;
    align-items: center;
    /* justify-content: flex-start; */
    margin-top: 20px;

    & .list-title {
      width: 10em;
			min-width: 110px;
      & p {
        font-family: "Spoqa700";
        font-size: 0.88em;
        color: #2a3a4b;
      }
    }
    & .list-input {
			width: 100%;
      min-width: 100px;

			& input{
				width: 100%;
				padding: 8px 12px;
				border: 1px solid #c9c9c9;
				border-radius: 4px;
				font-size: 0.88em;
			}

      & input[type="text"] {
        width: 100%;
        &#feedPurchaseDate {
          width: 50%;
        }
        &.bg {
          background: #eee;
        }
      }

      & input[type="date"], input[type="time"] {
				width: 160px;
      }

			& input[type="number"] {
				width: 100%;
			}
    }
  }
`;

export const Boxsearch = styled.div`
  width: 100%;
  padding: 22px 0px 22px 40px;
  background-color: #fff;
  border-bottom: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;
  margin-top: 8px;

  & .boxsearch-title {
    font-family: "spoqa700";
    font-size: 1em;
  }
  & .boxsearch-box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 13px;

    & .boxsearch-item {
      width: 30%;
      &:nth-child(2) {
        margin-left: 20px;
      }

      & p {
        font-size: 0.88em;
        font-family: "spoqa400";
        color: #656565;
      }

      & select {
        width: 100%;
        margin-top: 4px;
        padding: 10px 0px 10px 8px;
        font-size: 0.88em;

        border: 1px solid #c9c9c9;
        border-radius: 3px;
        color: #2a3a4b;
        -webkit-appearance: none;
        background: url("./img/SelectArrow.svg") no-repeat;
        background-position: 98%;
      }
    }
  }
`;

export const BoxItemBox = styled.div`
  width: 100%;
  background-color: #fff;
  margin-top: 8px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  padding: 20px 40px;
  & .item-title {
    font-family: "spoqa700";
    font-size: 1.13em;
    color: #2a3a4b;
  }

  & .box-list {
    width: 100%;
    margin-top: 15px;
    position: relative;
    & .box-name {
      font-size: 1em;
      color: #2a3a4b;
    }

    & .box-content {
      display: flex;

      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 5px;
      & p {
        font-family: "spoqa400";
        font-size: 0.88em;
      }

      & .box-date {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        & input[type="date"] {
          border: 1px solid #c9c9c9;
          border-radius: 3px;
          margin-left: 3px;
        }
      }

      & .btn-box {
        display: block;
      }
      & button {
        font-size: 0.88em;
        border: 1px solid #73972c;
        color: #73972c;
        padding: 5px 16px;
        border-radius: 5px;
        background-color: #fff;
        margin-left: 10px;
        cursor: pointer;
        &:active {
          background-color: #73972c;
          border: 1px solid #73972c;
          color: #fff;
        }
        &:first-child {
          margin: 0;
        }
      }
    }

    @media screen and (min-width: 1050px) {
      & .box-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 5px;

        & p {
          font-family: "spoqa400";
          font-size: 0.88em;
          /* width: 250px; */
        }

        & .box-date {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          & input[type="date"] {
            border: 1px solid #c9c9c9;
            border-radius: 3px;
            margin-left: 3px;
          }
        }

        & .btn-box {
          display: block;
        }
        & button {
          font-size: 0.88em;
          border: 1px solid #73972c;
          color: #73972c;
          padding: 5px 16px;
          border-radius: 5px;
          background-color: #fff;
          margin-left: 10px;
          cursor: pointer;
          &:active {
            background-color: #73972c;
            border: 1px solid #73972c;
            color: #fff;
          }
          &:first-child {
            margin: 0;
          }
        }
      }
    }
  }
`;

export const AddBoxItemContainer = styled.div`
  width: 100%;
  background-color: #fff;
`;

export const AddBoxItemList = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 40px;

  & .Itemlist {
    flex: 1;

    & p {
      font-size: 0.88em;
      font-family: "spoqa400";
      color: #656565;
    }

    & select {
      width: 90%;
      padding: 5px 8px;
      font-size: 0.88em;
      margin-top: 5px;
      border: 1px solid #c9c9c9;
      border-radius: 3px;
      color: #2a3a4b;
      -webkit-appearance: none;
      background: url("./img/SelectArrow.svg") no-repeat;
      background-position: 98%;
    }

    & input[type="date"]::-webkit-calendar-picker-indicator {
      background: none;
      z-index: 1;
    }

    & input[type="date"] {
      width: 90%;
      padding: 5px 8px;
      font-size: 0.88em;
      margin-top: 5px;
      border: 1px solid #c9c9c9;
      border-radius: 3px;
      color: #2a3a4b;
      -webkit-appearance: none;
      background: url("./img/SelectArrow.svg") no-repeat;
      background-position: 98%;
    }
    & input[type="text"] {
      width: 90%;
      padding: 5px 8px;
      font-size: 0.88em;
      margin-top: 5px;
      border: 1px solid #c9c9c9;
      border-radius: 3px;
      color: #2a3a4b;
    }
  }

  @media screen and (min-width: 1050px) {
    & .Itemlist {
      & p {
        font-size: 1.13em;
        font-family: "spoqa400";
        color: #656565;
      }

      & select {
        width: 90%;
        padding: 7px 8px;
        font-size: 1.13em;
        margin-top: 5px;
      }
      & input[type="date"] {
        width: 90%;
        padding: 7px 8px;
        font-size: 1.13em;
        margin-top: 5px;
      }
      & input[type="text"] {
        width: 90%;
        padding: 7px 8px;
        font-size: 1.13em;
        margin-top: 5px;
      }
    }
  }
`;

export const ModalContainer = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;
export const BoxMovingModal = styled.div`
  width: 80%;
  background-color: #fff;
  height: 500px;
  position: relative;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d4d3d3;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  & .modal-close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }

  & .item-list {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 20px;

    & .item {
      font-size: 1.2em;
      width: calc(50% - 20px);
      padding: 20px;
      text-align: center;
      margin-top: 15px;
      box-shadow: 6px 4px 7px 0px #b7a8a8;
      cursor: pointer;
      &:nth-child(2n) {
        margin-left: 20px;
      }

      &:active {
        position: relative;
        top: 2px;
        left: 2px;
        box-shadow: 2px 2px 7px 0px #b7a8a8;
      }
    }
  }
`;
export const BoxModifyModal = styled.div`
  background-color: #fff;
  padding: 40px;
  position: relative;
  box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12);
  border-radius: 8px;
  & .modal-close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }

  & .input-list {
    width: 100%;
		margin-bottom: 20px;

    & .input-name {
      font-size: 1.2em;
      margin: 5px 0px;
    }
    & input {
      width: 100%;
      padding: 4px 12px;
      border: 1px solid #9e9494;
      border-radius: 3px;
			height: 40px;
    }
    & select {
      width: 100%;
      padding: 4px 12px;
      border: 1px solid #9e9494;
      border-radius: 3px;
			height: 40px;
    }
  }

  .btn-box {
    width: 100%;
    display: flex;
    align-content: center;
    justify-content: space-between;
    margin-top: 20px;
    & button {
      width: 48%;
      background: #fff;
			border: 1px solid #73972c;
			border-radius: 4px;
			padding: 8px 0px;
			background-color: #73972c;
			color: #fff;
			&:hover{
				cursor: pointer;
				filter: brightness(110%);
			}
    }
  }
`;

export const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 40px;
  margin-top: 20px;

  & button {
    font-size: 0.88em;
    border: 1px solid #73972c;
    color: #73972c;
    width: 60px;
    padding: 5px 5px;
    border-radius: 5px;
    background-color: #fff;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    &:active {
      background-color: #73972c;
      border: 1px solid #73972c;
      color: #fff;
    }

    &.remove {
      color: #656565;
      border: 1px solid #656565;
      &:active {
        background-color: #656565;
        border: 1px solid #656565;
        color: #fff;
      }
    }

    & .radius {
      border: 1px solid #656565;
      width: 18px;
      height: 18px;
      border-radius: 50%;

      &.add {
        border: 1px solid #73972c;
      }
    }
  }
`;


// noData
export const NoData = styled.div`
	padding: 20px;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	height: 100%;
	color:rgb(101, 101, 101);
`;